(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/gameloader-helper.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/gameloader-helper.js');
const { useLocalGameLoaderHelper } = svs.utils.url.queryString;
(useLocalGameLoaderHelper === 'true') && (() => {
  'use strict';
  console.log('Using local Game Loader Helper!');
  var e = {
      d: (t, n) => {
        for (var o in n)
          e.o(n, o) &&
            !e.o(t, o) &&
            Object.defineProperty(t, o, {
              enumerable: !0,
              get: n[o]
            });
      },
      o: (e, t) => Object.prototype.hasOwnProperty.call(e, t)
    },
    t = {};
  e.d(t, {
    default: () => R
  });
  const n = '2.8.0',
    o = 'Content-Type',
    a = 'Accept',
    i = 'X-Client-Name',
    r = 'X-Client-Version',
    s = 'auth',
    c = '1.4.0',
    l = '/itf-gateway/rest';
  let d;
  const h = 'setNotifier',
    m = 'gameloader-helper-style',
    u = 'gameloader-helper-class',
    f = 'gameloader-helper-layout';
  function g(e) {
    if (e.getElementById(m)) return;
    const t = e.createElement('style');
    ((t.id = m),
      (t.type = 'text/css'),
      (t.textContent = `\n\t\t.${u} {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmargin: 0;\n\t\t\tpadding: 0;\n\t\t\tborder: 0;\n\t\t}\n\n\t\t.${f} {\n\t\t\tposition: relative !important;\n\t\t\twidth: 100% !important;\n\t\t\theight: 100% !important;\n\t\t}\n\t`),
      e.head.appendChild(t));
  }
  function p(e) {
    if (0 === e.length) return;
    g(e[0].ownerDocument);
    for (const t of e) t.classList.add(u);
  }
  function y(e) {
    for (const t of e) t.classList.remove(u);
  }
  class w {
    bridgeWindow;
    origin;
    constructor(e, t) {
      ((this.bridgeWindow = e), (this.origin = t));
    }
    notifyPurseInformationChange(e) {
      this.sendNotification('notifyPurseInformationChange', e);
    }
    notifySoundStatus(e) {
      this.sendNotification('notifySoundStatus', e);
    }
    notifyPause(e) {
      this.sendNotification('notifyPause', e);
    }
    notifyGameModeChange(e) {
      this.sendNotification('notifyGameModeChange', e);
    }
    notifyLocaleInformationChange(e) {
      this.sendNotification('notifyLocaleInformationChange', e);
    }
    notifyUserInformationChange(e) {
      this.sendNotification('notifyUserInformationChange', e);
    }
    notifyStartGame() {
      this.sendNotification('notifyStartGame');
    }
    sendNotification(e, t) {
      const n = {
        result: {
          type: e,
          data: t
        },
        id: -1
      };
      this.bridgeWindow.postMessage(n, this.origin);
    }
  }
  function v(e, t) {
    const n = new URL(e),
      o = (function (e) {
        const t = {};
        for (const n in e)
          if (e.hasOwnProperty(n)) {
            const o = e[n];
            if (null == o) continue;
            switch (typeof o) {
              case 'string':
                '' !== o && (t[n] = o);
                break;
              case 'number':
              case 'boolean':
                t[n] = String(o);
                break;
              case 'object':
                t[n] = JSON.stringify(o);
                break;
              default:
                throw new Error('Unhandled type ' + typeof o, {
                  cause: {
                    code: 'NonQueryParam',
                    value: o
                  }
                });
            }
          }
        return t;
      })(t);
    for (const e in o) n.searchParams.append(e, o[e]);
    return n.href;
  }
  class E {
    gameloaderHelper;
    static HELPER_REGISTRY = {};
    parentNode;
    notifierProxy = null;
    initializeParameters;
    bridgeFrame;
    bridgeWindow;
    channel;
    channelId;
    savedEmitEvent;
    _onMessageEvent;
    constructor(e, t) {
      this.gameloaderHelper = t;
      const { parentNode: n, hostChannel: o, gameloader: a } = e;
      ((this.parentNode = n),
        (this.channel = o),
        (this.channelId = E.generateChannelId()),
        (this.initializeParameters = (function (e) {
          const { parentNode: t, hostChannel: n, crossDomain: o, gameloader: a, ...i } = e;
          return {
            ...i,
            ...a
          };
        })(e)));
      const i = {
        channelId: this.channelId,
        configurationPath: a.configurationPath,
        hostKey: e.crossDomain.hostKey
      };
      !(function (e, t) {
        const {
          crossDomain: n,
          betId: o,
          skipRules: a,
          gameMode: i,
          lotteryChannel: r,
          platform: s,
          gameSpecificParameters: c,
          language: l,
          theme: d,
          soundEnabled: h
        } = {
          ...e,
          ...e.gameloader
        };
        (n && n.authorizedHosts && (t['host-key'] = n.hostKey),
          o && (t.betId = o),
          a && (t.skipRules = Boolean(a)),
          i && (t.gameMode = i),
          r && (t.lotteryChannel = r),
          s && (t.platform = s),
          c && (t.gameSpecificParameters = c),
          l && (t.language = l),
          d && (t.theme = d),
          (!1 === h || h) && (t.soundEnabled = h ?? !1));
      })(e, i);
      const r = v(a.url, i);
      ((this._onMessageEvent = (e) => this.onMessageEvent(e)),
        window.addEventListener('message', this._onMessageEvent),
        (this.savedEmitEvent = this.channel.emitEvent),
        (this.channel.emitEvent = (e, t) => this.onEmitEvent(e, t)),
        (this.bridgeFrame = this.createBridgeWindow(r)),
        p([this.bridgeFrame, this.parentNode, this.parentNode.ownerDocument.body, this.parentNode.ownerDocument.documentElement]),
        (this.bridgeWindow = this.appendBridgeWindow()),
        (E.HELPER_REGISTRY[this.channelId] = this));
    }
    createBridgeWindow(e) {
      const t = document.createElement('iframe');
      return ((t.allowFullscreen = !0), (t.src = e), t.classList.add(u), t);
    }
    appendBridgeWindow() {
      this.parentNode.appendChild(this.bridgeFrame);
      const e = this.bridgeFrame.contentWindow;
      if (null === e) throw new Error('Unable to retrieve iframe window object');
      return e;
    }
    close() {
      (window.removeEventListener('message', this._onMessageEvent),
        y([this.bridgeFrame, this.parentNode, this.parentNode.ownerDocument.body, this.parentNode.ownerDocument.documentElement]),
        null !== this.bridgeFrame.parentNode ? this.bridgeFrame.parentNode.removeChild(this.bridgeFrame) : console.error('game div has already been cleanup.'),
        delete E.HELPER_REGISTRY[this.channelId],
        (this.gameloaderHelper.instance = null));
    }
    onEmitEvent(e, t) {
      return this.savedEmitEvent.apply(this.channel, [e, t]);
    }
    onMessageEvent(e) {
      const t = e.data;
      if (!t || !t.functionName) return;
      if (t.channelId && t.channelId !== this.channelId) return;
      const n = t.functionName;
      '__init__' === n
        ? this.onInitializationEvent(e.origin, t)
        : n === h
          ? this.onSetNotifierEvent(e.origin)
          : n in this.channel
            ? this.onFunctionCallEvent(e.origin, t, n)
            : n && this.onUnhandledFunctionCallEvent(e.origin, t, n);
    }
    onUnhandledFunctionCallEvent(e, t, n) {
      if ('getRevealParameters' === n) (console.warn(`attempting to call unknown or unimplemented host function ${n} using default parameters`), this.sendResult(e, t, {}));
      else console.error('attempting to call unknown or unimplemented host function ' + n, event);
    }
    onInitializationEvent(e, t) {
      const n = {
        type: this.channel.type,
        name: this.channel.name,
        initializeParameters: {
          ...this.initializeParameters,
          exchangeToken: k
        }
      };
      this.sendResult(e, t, n);
    }
    onFunctionCallEvent(e, t, n) {
      const o = this.channel[n].apply(this.channel, t.parameters);
      o &&
        (o instanceof Promise
          ? o
              .then((n) => {
                this.sendResult(e, t, n);
              })
              .catch((n) => {
                this.sendResult(e, t, String(n), !0);
              })
          : this.sendResult(e, t, o));
    }
    onSetNotifierEvent(e) {
      ((this.notifierProxy = new w(this.bridgeWindow, e)), h in this.channel && 'function' == typeof this.channel.setNotifier && this.channel.setNotifier(this.notifierProxy));
    }
    sendResult(e, t, n, o) {
      if (void 0 === t.id) return;
      const a = (n, o) => {
        const a = {
          result: n,
          id: t.id,
          error: o
        };
        this.bridgeWindow.postMessage(a, e);
      };
      null !== n && 'object' == typeof n && 'then' in n ? n.then((e) => a(e)).catch((e) => a(e.message, !0)) : a(n, o);
    }
    static ChannelNextIndex = 0;
    static generateChannelId() {
      return String(++E.ChannelNextIndex);
    }
  }
  const b = [];
  let N,
    C = !0;
  function P(e, t) {
    C
      ? b.push({
          methodName: e,
          args: t
        })
      : S(e, t, N);
  }
  function S(e, t, n) {
    const o = e.split('.');
    let a = n;
    for (let e = 0; e < o.length - 1; e++) a = a[o[e]];
    const i = o[o.length - 1];
    'function' == typeof a[i] && a[i](...t);
  }
  const I = {
    close: () => P('close', []),
    notifierProxy: {
      notifyPause: (...e) => P('notifierProxy.notifyPause', e),
      notifyPurseInformationChange: (...e) => P('notifierProxy.notifyPurseInformationChange', e),
      notifySoundStatus: (...e) => P('notifierProxy.notifySoundStatus', e),
      notifyStartGame: (...e) => P('notifierProxy.notifyStartGame', e)
    }
  };
  let k;
  const R = new (class {
    version;
    instance = null;
    parentNode = null;
    constructor(e) {
      this.version = e;
    }
    openGame(e) {
      if (null !== this.instance) throw new Error('openGame has already been called');
      this.parentNode = e.parentNode;
      const t = e.gameloader;
      return (
        (async () => {
          ('RGS' === t.engineType && 'DEMO' !== t.gameMode && (k = (await this.authenticate(e)).access_token), (t.url ??= e.bridgeLocation ?? (await this.fetchBridgeLocation(e))));
          const n = !0 === e.gameloader.accessibleMode,
            o = 'GDK4' === t.name;
          (n &&
            ((e.gameloader.name = 'GDK4'), (e.gameloader.url = e.gameloader.url?.replace('/bridge2/', '/bridge4/')), console.log('Accessibility mode enabled: forcing bridge 4 url in gameloader.url')),
            o || n
              ? (p([e.parentNode, e.parentNode.ownerDocument.body, e.parentNode.ownerDocument.documentElement]),
                n && (e.gameloader.driverName = 'accessibility'),
                (this.instance = await this.loadDriver(e, this)))
              : (this.instance = new E(e, this)),
            (function (e) {
              for (const { methodName: t, args: n } of b) S(t, n, e);
              ((b.length = 0), (C = !1), (N = e));
            })(this.instance));
        })(),
        I
      );
    }
    closeGame() {
      if (this.instance) {
        const e = this.parentNode ?? null;
        (e && y([e, e.ownerDocument.body, e.ownerDocument.documentElement]), this.instance.close());
      } else console.warn('there is no game to close');
    }
    close() {
      this.closeGame();
    }
    async authenticate(e) {
      const t = e.gameloader.lotteryCode,
        n = e.gameloader.lotteryChannel,
        h = 'DEMO_AUTH' === e.gameloader.gameMode,
        baseUrl = e.gameloader.servicesBaseUrl;
      if (void 0 === t) throw new Error('Missing lotteryCode for authenticate method.');
      let m, u, f;
      const g = () =>
          (async function (e) {
            const { lotteryCode: t, lotteryChannel: n, baseUrl: a = window.location.origin, ...h } = e;
            if (!(!0 === h.demoMode || (h.state && h.token))) throw new Error("'state' or 'token' must no be empty.");
            const m = {
                lottery: t,
                channel: n,
                ...h,
                state: h.state || 'dummy_state',
                token: h.token || 'dummy_token'
              },
              u = new URL(l + '/itf/session', a),
              f = await fetch(u, {
                method: 'POST',
                cache: 'no-store',
                headers: {
                  [o]: 'application/vnd.lotsys.itf.session.request-1+json',
                  [i]: s,
                  [r]: c
                },
                body: JSON.stringify(m)
              });
            if (204 === f.status) return (void 0 === d && console.warn('Session cookie has already been set.'), d);
            if (200 !== f.status)
              throw new Error('Failed to retrieve the access token.', {
                cause: f
              });
            return ((d = await f.json()), d);
          })({
            lotteryCode: t,
            token: u,
            state: m,
            demoMode: h,
            lotteryChannel: n,
            baseUrl
          }),
        p = await (async function (e) {
          const { lotteryCode: t, lotteryChannel: n, baseUrl: a = window.location.origin } = e,
            d = new URL(l + '/itf/session/state', a);
          d.searchParams.append('lottery', t);
          const h = await fetch(d, {
            method: 'GET',
            cache: 'no-store',
            headers: {
              [o]: 'application/vnd.lotsys.itf.session.state.info-1+json',
              [i]: s,
              [r]: c
            }
          });
          if (200 !== h.status)
            throw new Error('Failed to retrieve the access token.', {
              cause: h
            });
          const m = await h.json();
          if (m?.redirectUrl && n) {
            const e = new URL(m.redirectUrl, a);
            (e.searchParams.append('channel', n), (m.redirectUrl = e.href));
          }
          return m;
        })({
          lotteryCode: t,
          lotteryChannel: n,
          baseUrl
        });
      if (((m = p.state), void 0 === m)) throw new Error('Authentication state is missing.');
      const { sessionToken: y } = await e.hostChannel.getUserInformation(!0, p.state, p);
      if (((u = y?.value), void 0 !== y && (f = await g()), void 0 === f)) throw new Error('Failed to retrieved the session.');
      const w = e.gameloader.engineCode;
      if (void 0 === w) throw new Error('Missing engineCode when engineType is RGS.');
      const v = await (async function (e) {
        const { engineCode: t, jwtToken: n, baseUrl: l = window.location.origin } = e,
          d = new URLSearchParams({
            grant_type: 'urn:ietf:params:oauth:grant-type:token-exchange',
            audience: t,
            subject_token: n,
            subject_token_type: 'urn:ietf:params:oauth:token-type:access_token'
          }),
          h = new URL('/itf-gateway/rest/itf/player/v1/identities/token', l),
          m = await fetch(h, {
            method: 'POST',
            cache: 'no-store',
            headers: {
              [a]: 'application/json',
              [o]: 'application/x-www-form-urlencoded',
              [i]: s,
              [r]: c
            },
            body: d.toString()
          });
        if (200 !== m.status)
          throw new Error('Failed to retrieve the access token.', {
            cause: m
          });
        return await m.json();
      })({
        baseUrl: e.gameloader.servicesBaseUrl,
        jwtToken: f.access_token,
        engineCode: w
      });
      return v;
    }
    async fetchBridgeLocation(e) {
      const { gameloader: t } = e;
      if (void 0 !== t.url) return t.url;
      const o = this.resolveGameloadersPath(t),
        a = await (
          await fetch(o, {
            method: 'GET',
            headers: {
              [i]: 'gameloader-helper',
              [r]: n
            }
          })
        ).json();
      let s;
      try {
        ((s = a[t.name ?? 'FGS_BRIDGE']), void 0 === s && 'GDK4' === t.name && (s = a.FGS_BRIDGE.replace('/bridge2/', '/bridge4/')));
      } catch (e) {
        throw new Error(`Failed to parse ${o}`);
      }
      if (void 0 === s) throw new Error(`No matching provider for ${t.name} in ${o}`);
      return s;
    }
    resolveGameloadersPath(e) {
      let t;
      if (void 0 !== e.gameloadersPath) t = e.gameloadersPath;
      else {
        const e = document.currentScript;
        if (null !== e && 'object' == typeof e) {
          const n = e.src;
          t = n.substring(0, n.lastIndexOf('/') + 1) + 'gameloaders.json';
        }
      }
      if (void 0 === t) throw new Error('document.currentScript is null, you must provide gameloadersPath as fallback.');
      return t;
    }
    async loadDriver(e, t) {
      const n = e.gameloader.url,
        o = n.split('/');
      o.splice(-2, 2, 'libs');
      const a = o.join('/'),
        i = `${a}/driver-${e.gameloader.driverName ?? 'fdj'}`,
        r = document.createElement('div');
      var s;
      (p([r, e.parentNode]),
        g((s = e.parentNode).ownerDocument),
        s.classList.add(f),
        e.parentNode.prepend(r),
        await (async function (e) {
          return new Promise((t, n) => {
            const o = document.createElement('script');
            ((o.type = 'text/javascript'),
              (o.src = e),
              (o.async = !0),
              (o.onload = () => t()),
              (o.onerror = (t) =>
                n(
                  new Error(`Failed to load script: ${e}`, {
                    cause: t
                  })
                )),
              document.head.appendChild(o));
          });
        })(`${i}/index.js`));
      const c = globalThis.gamedriver;
      this.instance = c.start({
        ...e,
        parentNode: r,
        lotteryGameCode: e.hostChannel.name,
        engineCode: e.hostChannel.type,
        bridgeLocation: n,
        pluginsFolder: a,
        driverFolder: i
      });
      const l = this.instance.close;
      return {
        ...this.instance,
        close: () => {
          (y([r, e.parentNode]),
            (function (e) {
              e.classList.remove(f);
            })(e.parentNode),
            l(),
            (t.instance = null));
        }
      };
    }
  })('2.8.0');
  window.gameloaderHelper = t.default;
})();


 })(window);